import graphqlClient from '@/graphql/graphql-client';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  DeleteOrgCompanyDocument,
  type DeleteOrgCompanyMutationVariables,
} from '@/graphql/generated/graphql';

export const useDeleteOrgCompany = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationKey: ['delete-org-company'],
    mutationFn: (variables: DeleteOrgCompanyMutationVariables) =>
      graphqlClient.request(DeleteOrgCompanyDocument, variables),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['companies'] });
    },
  });

  return {
    ...mutation,
    deleteOrgCompany: mutation.mutate,
    deleteOrgCompanyAsync: mutation.mutateAsync,
  };
};

export const DELETE_COMPANY_MUTATION = DeleteOrgCompanyDocument;
